import client from './request'

const get = `/user/announcement`

const AnnouncementService = {
  get
}

export default AnnouncementService
